import { Select } from 'components/Form'
import useMonthList from '../hooks/useMonthList'
import useYearList from '../hooks/useYearList'

const Header = ({ filter, setFilter }) => {
	const monthList = useMonthList()
	const yearList = useYearList()
	const { month, year } = filter
	return (
		<div className='flex items-center justify-between'>
			<h1 className='text-[18px] lg:text-[24px] text-[#292A32] dark:text-[#ffffff] font-semibold'>
				Dashboard
			</h1>
			<div className='flex items-center gap-3'>
				<div className='w-[100px] sm:w-[150px]'>
					<Select
						isClearable={false}
						isSearchable={false}
						size='small'
						isDisabled={
							yearList.filter(item => Number(item?.value) >= 2025)?.length < 2
						}
						options={yearList.filter(item => Number(item?.value) >= 2025)}
						value={yearList?.find(item => item.value === year)}
						onChange={({ value }) => setFilter({ ...filter, year: value })}
					/>
				</div>
				<div className='w-[120px] sm:w-[150px]'>
					<Select
						isClearable={false}
						isSearchable={false}
						size='small'
						options={monthList}
						value={monthList?.find(item => item.value === month)}
						onChange={({ value }) => setFilter({ ...filter, month: value })}
					/>
				</div>
			</div>
		</div>
	)
}

export default Header
